import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoadingPanel } from "src/components/loadingPanel";
import { getTenantCookieData, getUserCredential } from "src/lib/cookies";
import useApproverDashboard from "./service";
import { DEFAULT_SORT } from "src/constants/grid";
import { getDateRangeByPeriod, getUserTimezone } from "../providerPayRequestDashboard/utils/dateUtils";
import { formatTimesheetQuantity } from "../providerPayRequestDashboard/utils/thresholdQuantity";
import { convertTimeZone, formatServiceDate, transformDateTime } from "src/lib/date-time.util";
import { convertHexToRgba, formatDate, getfilterDataString } from "src/utils/utils";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { columnMenuProps } from "src/components/customColumnMenu";
import DataTable from "src/components/dataTable";
import PendingApprovalDialog from "./components/PendingApprovalDialog";
import { HeaderPage } from "../base/headerPage";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import { CellRender, RowRender } from "src/components/renderers";
import ConfirmDialog from "./components/ConfirmDialog";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { DialogComponent } from "src/components/dialog";
import { APPROVE_BTN_ACTIONS, REJECT_BTN_ACTIONS } from "src/constants/constants";
import { GetSystemConfigDataByCode } from "src/lib/common-service";
import MultiSelect from "src/components/multiSelect";
import { filterBy } from "@progress/kendo-react-data-tools";
import { getAllPayRequestType } from "../payRequestTracker/services/getAllPayRequestType";
import { getAllProviders } from "../payRequestTracker/services/getAllProviders";
import { getAllApproverDropdown } from "../payRequestTracker/services/getApproverDropddown";

const editField = "inEdit";

const getQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    timesheetId: searchParams.get("id"), // timesheet_mstr_key from notification
    status: searchParams.get("status")?.toLowerCase(), // status from notification
  };
};

const ProviderRequest = (pageProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const cookiesData = getUserCredential();
  const defaultPageSize = getTenantCookieData("record_per_page");

  const [list, Action] = useApproverDashboard();
  const [holdEnabled, setHoldEnabled] = useState(undefined);
  const {
    data,
    columns,
    dataCount,
    initialLoading,
    isRefreshLoading,
    isAPICalling,
    originalData,
    setData,
    setAPICallingState,
  } = list;
  const [selectedTab, setSelectedTab] = useState();
  const [isHeaderChecked, setIsHeaderChecked] = useState(false);
  const [columnData, setColumnData] = useState([]);
  const [isCheckColumn, setCheckColumn] = useState(false);
  const [viewDialogData, setViewDialogData] = useState({ isVisible: false, data: null });
  const [pageData, setPage] = React.useState({
    skip: 0,
    take: defaultPageSize.recordTake,
  });
  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const [gridColumns, setGridColumns] = useState([]);
  const [filterData, setFilterData] = useState({
    isSort: false,
    isFilter: false,
    data: "",
    in_sort_number: DEFAULT_SORT.number,
    in_sort_order: DEFAULT_SORT.order,
  });
  const [filterField, setFilterField] = useState({
    logic: "and",
    filters: [],
  });
  const [sortField, setSortField] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [dateErrors, setDateErrors] = useState({ startDate: "", endDate: "" });
  const [exportDataClick, setExportDataClick] = useState(false);
  const [exportData, setExportData] = useState([]);
  //  const [rejectDialogVisible, setRejectDialogVisible] = useState(false)
  //  const [approveDialogVisible, setApproveDialogVisible] = useState(false)
  const [serarchFilter, setSearchFilter] = useState(false);
  const [selectedTimesheetKeys, setSelectedTimesheetKeys] = useState(new Set());
  const [transformPayRequestData, setTransformPayRequestData] = useState([]);
  const [transformProviderData, setTransformProviderData] = useState([]);

  const [confirmationPopup, setConfirmationPopup] = React.useState({
    title: "",
    desc: "",
    isVisible: false,
    type: "",
    actionBtn: [],
    data: {},
    action: "",
    isCustomDesc: false,
    customComponent: null,
  });

  // Shown after an approval that landed on Hold (backend returns heldTimesheetMstrKey).
  const [holdPopup, setHoldPopup] = React.useState({ isVisible: false });
  const selectAllOption = { id: "Select All", text: "Select All" };

  const [payRequestTypeFields, setPayRequestTypeFields] = useState({
    payRequestTypeData: [selectAllOption],
    payRequestTypeDataValue: [selectAllOption],
    filterValue: "",
    isPayRequestTypeDataLoading: true,
    search: "",
  });

  const [providerFields, setProviderFields] = useState({
    providerData: [selectAllOption],
    providerDataValue: [selectAllOption],
    filterValue: "",
    isProviderDataLoading: true,
    search: "",
  });


  const onOpenChange = (setDataFields, moduleData, key, dataFields, dataFieldsValue) => {
    let dataValue =
      dataFields.filterValue && dataFields.filterValue !== ""
        ? filterBy(dataFieldsValue.slice(), dataFields.search)
        : moduleData;
    setDataFields((prev) => ({
      ...prev,
      [`${key}`]: dataValue,
    }));
  };

  const filterChange = (filteredData, setDataFields, moduleData, key) => {
    setDataFields((prev) => ({
      ...prev,
      [`${key}`]: filteredData,
    }));
  };

  const handleBlurDropdown = (setDataFields) => {
    setDataFields((prev) => ({
      ...prev,
      filterValue: "",
      search: "",
    }));
  };

  const getDropdownData = async () => {
    setPayRequestTypeFields((prev) => ({
      ...prev,
      isPayRequestTypeDataLoading: true,
    }));
    setProviderFields((prev) => ({
      ...prev,
      isProviderDataLoading: true,
    }));

    try {
      const response = await getAllApproverDropdown(cookiesData, dispatch);
      const rowResult = response?.data?.row_result || {};

      const transformedPayRequestTypes = (rowResult.contract_type || []).map((item) => ({
        id: item.contract_type_mstr_key,
        text: item.contract_type,
      }));

      setTransformPayRequestData(transformedPayRequestTypes);
      setPayRequestTypeFields((prev) => ({
        ...prev,
        payRequestTypeData: transformedPayRequestTypes,
        payRequestTypeDataValue: transformedPayRequestTypes.length > 0 ? [{ id: "Select All", text: "Select All" }] : [],
      }));

      const transformedProviderData = (rowResult.providers || []).map((item) => ({
        id: item.provider_mstr_key,
        text: item.provider_name,
      }));
      setTransformProviderData(transformedProviderData);
      setProviderFields((prev) => ({
        ...prev,
        providerData: transformedProviderData,
        providerDataValue: transformedProviderData.length > 0 ? [{ id: "Select All", text: "Select All" }] : [],
      }));

      return response;
    } finally {
      setPayRequestTypeFields((prev) => ({
        ...prev,
        isPayRequestTypeDataLoading: false,
      }));
      setProviderFields((prev) => ({
        ...prev,
        isProviderDataLoading: false,
      }));
    }
  };
  useEffect(() => {
    getDropdownData();
  }, []);

  const getInFilter = () => {
    let filterStr = filterData.data;
    if (pageProps?.location?.state?.defaultKeys) {
      let contract_name_mstr_key = pageProps.location?.state?.defaultKeys?.contract_name_mstr_key
        ? `AND ( temp.contract_name_mstr_key = ${pageProps.location?.state?.defaultKeys?.contract_name_mstr_key} )`
        : "";

      filterStr =
        ` AND ( temp.provider_mstr_key = ${pageProps.location?.state?.defaultKeys?.provider_mstr_key} ) AND ( temp.contract_type_mstr_key = ${pageProps.location?.state?.defaultKeys?.contract_type_mstr_key} ) ` +
        contract_name_mstr_key +
        filterData.data;
    }

    //return filterData.isFilter ? filterStr : null
    return filterStr;
    // return filterData.isFilter ? pageProps.location?.state?.provider_mstr_key ? ` AND temp.provider_mstr_key=${pageProps.location?.state?.provider_mstr_key} ${filterData.data} `:  filterData.data : null
  };

  const getInSortNumber = () => {
    return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
  };

  const getInSortOrder = () => {
    return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
  };

  const getCommaSeparatedIds = (selectedItems) => {
    if (!selectedItems || selectedItems.length === 0) return null;
    return selectedItems
      .map((item) => item.id)
      .filter((id) => id !== "Select All")
      .join(",");
  };

  const apiCallData = {
    in_tenant_id: cookiesData.out_tenant_id,
    in_approver_mstr_key: cookiesData.out_user_id,
    in_platform_key: "web",
    in_status: null, // Based on selected tab, ALL, PENDING, APPROVED, REJECTED if ALL then null to be sent.
    in_filter: getInFilter(),
    in_sort_number: getInSortNumber(),
    in_sort_order: getInSortOrder(),
    in_page_row_offset: pageData.skip,
    in_page_rows: pageData.take,
    in_load_type: "data-reload",
  };

  const getGridData = async (payload) => {
    const res = await Action.fetchTimesheetsDataAsync(payload);
  };

  const updateFilters = (filters) => {
    return filters.map((filter) => {
      if (filter.field === "status") {
        return { ...filter, field: "approval_status" };
      }

      if (filter.filters && filter.filters.length > 0) {
        return { ...filter, filters: updateFilters(filter.filters) };
      }
      return filter;
    });
  };

  const handleColumnMenu = (columnMenuData, isFilter, isSort, filterObj) => {
    if (isSort) {
      setSortField(columnMenuData);
    } else {
      setFilterField(filterObj);
    }

    setPage({ skip: 0, take: defaultPageSize.recordTake });
    let index = 1;
    if (data.length > 0 && columnMenuData[0] !== undefined) {
      const sortStr = list.sortStr?.split("|");
      // let obj = Object.keys(data[0])
      // let sortNameField = ''

      //replace mstr key with name field only when sorting is applied
      // if (columnMenuData[0].field && columnMenuData[0].field.indexOf('_mstr_key')) {
      //     let sortKeyField = columnMenuData[0].field
      //     sortNameField = sortKeyField.replace('_mstr_key', '_name')
      // }

      index = sortStr.findIndex((x) => x === columnMenuData[0].field) + 1;
    }
    columnMenuData = updateFilters(columnMenuData);
    const filterString = isFilter ? getfilterDataString(columnMenuData, gridColumns) : filterData.data;

    isFilter = false;
    if (filterString !== "") {
      isFilter = true;
    }

    let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order : DEFAULT_SORT.order;
    let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : DEFAULT_SORT.number;

    isSort = !columnMenuData.length ? false : filterData.isSort;

    if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
      isSort = true;
      sortDir = columnMenuData[0].dir.toUpperCase();
      sortNumber = index;
    }

    setFilterData({
      ...filterData,
      isFilter: isFilter,
      isSort: isSort,
      data: filterString,
      in_sort_number: sortNumber,
      sort_order: sortDir,
    });
  };

  useEffect(() => {
    let filterStr = filterData.data;
    if (pageProps?.location?.state?.defaultKeys) {
      let contract_name_mstr_key = pageProps.location?.state?.defaultKeys?.contract_name_mstr_key
        ? `AND ( temp.contract_name_mstr_key = ${pageProps.location?.state?.defaultKeys?.contract_name_mstr_key} )`
        : "";

      filterStr =
        ` AND ( temp.provider_mstr_key = ${pageProps.location?.state?.defaultKeys?.provider_mstr_key} ) AND ( temp.contract_type_mstr_key = ${pageProps.location?.state?.defaultKeys?.contract_type_mstr_key} ) ` +
        contract_name_mstr_key +
        filterData.data;
    }

    setFilterData({
      ...filterData,
      data: filterStr,
      isFilter: true,
    });
  }, [pageProps?.location?.state?.defaultKeys]);

  const onClearFilter = () => {
    //setAPICallingState(true)
    setGridColumns([]);
    setSortField([]);
    setFilterField({ logic: "and", filters: [] });
    setPage({ skip: 0, take: defaultPageSize.recordTake });
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
      isSort: false,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
    });
  };

  const handlePageChange = async (event) => {
    setPage({ skip: event.page.skip, take: event.page.take });
  };

  const onRefreshClick = () => {
    setAPICallingState(true);
    setIsHeaderChecked(false);
    setPage({ skip: 0, take: defaultPageSize.recordTake });
    setSelectedTimesheetKeys(new Set());

    setFilterData({
      ...filterData,
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
    });
  };

  const handleDoubleClick = (event) => {
    setViewDialogData({ isVisible: true, data: event.originalProps.dataItem });
  };

  const handleItemChange = (event) => {
    const field = event.field || "";
    const newData = data.map((item) =>
      item.timesheet_mstr_key === event.dataItem.timesheet_mstr_key
        ? { ...item, [field]: event.value, inIteamEdit: true }
        : item
    );
    let editItem = event.dataItem;
    editItem[field] = event.value;
    setData(newData);
  };

  useEffect(() => {
    const dataVal = {
      ...apiCallData,
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_page_row_offset: pageData.skip,
      in_page_rows: pageData.take,
      in_load_type: "grid-reload",
    };

    if (startDate) {
      dataVal.in_start_date = `${transformDateTime({ date: startDate, format: "YYYY-MM-DD" })} 00:00:00`;
    }
    if (endDate) {
      dataVal.in_end_date = `${transformDateTime({ date: endDate, format: "YYYY-MM-DD" })} 23:59:59`;
    }

    const contractTypeIds = getCommaSeparatedIds(payRequestTypeFields.payRequestTypeDataValue);
    if (contractTypeIds) {
      dataVal.in_contract_type_mstr_key = contractTypeIds;
    }

    const providerIds = getCommaSeparatedIds(providerFields.providerDataValue);
    if (providerIds) {
      dataVal.in_provider_mstr_key = providerIds;
    }

    dataVal.in_status =
      selectedTab === "ALL"
        ? null
        : selectedTab === "PENDING"
          ? "new"
          : selectedTab === "APPROVED"
            ? "approved"
            : selectedTab === "HOLD"
              ? "hold"
              : selectedTab === "REJECTED"
                ? "rejected"
                : null; // ALL, PENDING, APPROVED, HOLD, REJECTED to default select tab and pass accordingly
    dataVal.in_device_local_tz = getUserTimezone();

    if (!startDate || !endDate || !selectedTab) return;
    if (exportDataClick) {
      getExportData(dataVal);
    } else {
      getGridData(dataVal);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, pageData, selectedTab, serarchFilter, exportDataClick]);

  useEffect(() => {
    if (!pageProps.location?.state) {
      const range = getDateRangeByPeriod("PYTD");
      setStartDate(range.startDate);
      setEndDate(range.endDate);
    }
    if (!startDate && pageProps?.location?.state?.startDate) {
      setStartDate(pageProps?.location?.state?.startDate);
    }
    if (!endDate && pageProps?.location?.state?.endDate) {
      setEndDate(pageProps?.location?.state?.endDate);
    }
  }, [pageProps.location?.state?.startDate, pageProps?.location?.state?.endDate]);

  useEffect(() => {
    if (!selectedTab && pageProps.location?.state?.status) {
      setSelectedTab(pageProps?.location?.state?.status?.toUpperCase());
    } else if (!selectedTab) {
      const searchParam = getQueryParams();
      if (!searchParam?.timesheetId && searchParam?.status) {
        setSelectedTab(searchParam?.status?.toUpperCase() ?? "ALL");
      } else if (searchParam?.timesheetId) {
        setSelectedTab(searchParam?.status?.toUpperCase() || "ALL");

        handleDoubleClick({
          originalProps: {
            dataItem: { timesheet_mstr_key: searchParam.timesheetId },
          },
        });
      }
    }
  }, [pageProps.location?.state?.status, selectedTab]);

  useEffect(() => {
    const loadHoldPref = async () => {
      const prefs = await GetSystemConfigDataByCode(
        {
          in_tenant_id: cookiesData.out_tenant_id,
          pref_code: ["sys_hold_status_notif"],
        },
        history,
        dispatch
      );
      setHoldEnabled(prefs?.sys_hold_status_notif === "1");
    };
    loadHoldPref();
  }, [cookiesData.out_tenant_id, dispatch, history]);

  useEffect(() => {
    if (holdEnabled !== false) return;
    setSelectedTab((tab) => (tab === "HOLD" ? "ALL" : tab));
  }, [holdEnabled]);

  useEffect(() => {
    if (columns.length > 0) {
      setColumnData(columns);
      setGridColumns(columns);
    }
  }, [columns]);

  const headerConfig = {
    title: "Pay Request Overview",
    id: "pay_request_overview_overview",
    manage_col: {
      columnsData: columnData,
      setColumnsData: setColumnData,
      setColumnCheck: setCheckColumn,
    },
    action_menu: {
      export: {
        fx: () => {
          // Only allow export if data exists
          if (dataCount > 0 && data.length > 0) {
            setExportDataClick(true);
          }
        },
        caption: "Export to Excel",
        disabled: dataCount === 0 || data.length === 0 || dateErrors.startDate || dateErrors.endDate,
      },
    },
    buttons: {
      template_fx: () => (
        <Button
          title="Back to Approval Dashboard"
          type="button"
          className="cancelbtn backbtn"
          id="grid-back-btn"
          onClick={() => history.goBack()}
        >
          <span className="k-button-text">
            <i className="fa fa-arrow-left"></i>
          </span>
        </Button>
      ),
    },
  };

  const handleTabChange = (tabStatus) => {
    setSelectedTab(tabStatus);
    setSelectedTimesheetKeys(new Set());
    setIsHeaderChecked(false);
    onClearFilter();
  };

  const handleStartDateChange = (event) => {
    const newStartDate = event.target.value;

    if (!newStartDate) {
      setDateErrors((prev) => ({ ...prev, startDate: "Please select start date" }));
      setStartDate();
      return;
    }

    if (newStartDate && endDate && newStartDate > endDate) {
      setDateErrors((prev) => ({ ...prev, startDate: "Start date must be before end date" }));
      setStartDate(newStartDate);
      return;
    }

    setDateErrors((prev) => ({ ...prev, startDate: "" }));

    setStartDate(newStartDate);
  };
  const handleEndDateChange = (event) => {
    const newEndDate = event.target.value;
    if (!newEndDate) {
      setDateErrors((prev) => ({ ...prev, endDate: "Please select end date" }));
      setEndDate();
      return;
    }

    if (startDate && newEndDate && startDate > newEndDate) {
      setDateErrors((prev) => ({ ...prev, endDate: "End date must be after start date" }));
      setEndDate(newEndDate);
      return;
    }

    setDateErrors((prev) => ({ ...prev, endDate: "" }));

    setEndDate(newEndDate);
  };

  const headerCheckboxOnChange = (e) => {
    setIsHeaderChecked((prev) => !prev);
    let finalData = data
      //.filter((x) => x.is_selected === (isHeaderChecked ? 1 : 0))
      .map((item) => {
        if ((item.status.timesheet_status_mstr_key === 1 || item.status.timesheet_status_mstr_key === 5)) {
          item.is_selected = e.target.checked ? 1 : 0;
          item.inIteamEdit = true;
          if (e.target.checked) {
            item.inIteamEdit = false;
          }
        }

        return item;
      });
    setData(finalData);

    setSelectedTimesheetKeys((prev) => {
      const newMap = new Map(prev);
      finalData.forEach((item) => {
        if (!isHeaderChecked && item.status.timesheet_status_mstr_key !== 4 && (item.status.timesheet_status_mstr_key === 1 || item.status.timesheet_status_mstr_key === 5)) {
          newMap.set(item.timesheet_mstr_key, {
            timesheet_mstr_key: item.timesheet_mstr_key,
            provider_name: item.provider_name,
            ts_date: item.ts_date,
            ts_date_local:item.ts_date_local,
            budget: item.budget,
            timesheet_status_mstr_key: item.status.timesheet_status_mstr_key,
          });
        } else {
          newMap.delete(item.timesheet_mstr_key);
        }
      });
      return newMap;
    });
  };

  const setkHeaderCheckbox = () => {
    let finalData = [...data];
    setIsHeaderChecked(finalData.length ? !finalData.filter((x) => x.is_selected === 0).length : 0);
  };

  const cellCheckboxOnChange = (e, props) => {
    if (props.onChange) {
      const { timesheet_mstr_key, provider_name, ts_date, ts_date_local, budget, status } = props.dataItem;
      setSelectedTimesheetKeys((prev) => {
        const newMap = new Map(prev);
        if (e.target.value && status.timesheet_status_mstr_key !== 4) {
          newMap.set(timesheet_mstr_key, { timesheet_mstr_key, provider_name, ts_date, ts_date_local, budget, timesheet_status_mstr_key: status.timesheet_status_mstr_key });
        } else {
          newMap.delete(timesheet_mstr_key);
        }
        return newMap;
      });
      props.onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value === true ? 1 : 0,
      });
      setkHeaderCheckbox();
    }
  };

  const SelectedPayRequestsList = ({ selectedItems, maxVisible = 10 }) => {
    const visibleItems = Array.from(selectedItems.values());

    const formatDate = (dateStr) => {
      if (!dateStr) return "N/A";
      return (
        convertTimeZone({
          date: dateStr,
          convertTimeZone: getUserTimezone(),
          outputFormat: "MM/dd/yyyy",
        }) || "N/A"
      );
    };

    const totalBudget = visibleItems.reduce((sum, item) => sum + Number(item.budget || 0), 0);

    return (
      <div className="selected-pay-requests-list">
        <div className="selection-header">
          <span className="timesheet-id">ID</span>
          <span className="provider-name">Provider</span>
          <span className="ts-date">Service Date</span>
          <span className="budget">Amount</span>
        </div>
        <div className="selection-items-scroll">
          {visibleItems.map((item) => (
            <div key={item.timesheet_mstr_key} className="selection-item">
              <span className="timesheet-id">{item.timesheet_mstr_key}</span>
              <span className="provider-name">{item.provider_name}</span>
              <span className="ts-date">{formatServiceDate(item.ts_date_local)}</span>
              <span className="budget">${Number(item.budget || 0).toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="selection-footer">
          <span className="footer-label">Total Amount</span>
          <span className="footer-value">${totalBudget.toFixed(2)}</span>
        </div>
        {visibleItems.length && (
          <div className="hidden-count">
            {visibleItems.length} pay request{visibleItems.length > 1 ? "s" : ""} selected
          </div>
        )}
      </div>
    );
  };

  // Custom Status Cell Renderer Component
  const StatusCell = (props) => {
    const status = props.dataItem.status;
    const statusData = status.display_name;
    const statusColor = status.color_code;
    const statusColorRgba = convertHexToRgba(statusColor, 0.1);
    const statusColorStyle = {
      backgroundColor: statusColorRgba,
      borderColor: statusColor,
      color: statusColor,
    };

    return (
      <td className="k-table-td" style={{ textAlign: "center", verticalAlign: "middle" }}>
        <span style={statusColorStyle} className="status-badge">
          {statusData}
        </span>
      </td>
    );
  };

  // Custom Status Cell Renderer Component
  const AmountCell = (props) => {
    const budget = props.dataItem.budget;

    return (
      <td className="k-table-td">
        <span>$ {budget.toFixed(2)}</span>
      </td>
    );
  };

  const QuantityCell = (props) => {
    const formatted = formatTimesheetQuantity(props.dataItem);

    return (
      <td className="k-table-td">
        <span>{formatted}</span>
      </td>
    );
  };

  const CheckboxCell = React.useCallback(
    (props) => {
      const { dataItem, render } = props;

      let value = props.field + dataItem.rowId;
      const defaultRendering = (
        <td>
          <Checkbox
            value={dataItem[props.field] === 1 ? true : false}
            onChange={(e) => {
              cellCheckboxOnChange(e, props, value);
            }}
            disabled={
              dataItem.status.timesheet_status_mstr_key !== 1 && dataItem.status.timesheet_status_mstr_key !== 5
            }
            autoComplete="off"
            name={`${props.field}`}
          />
        </td>
      );
      return render?.call(undefined, defaultRendering, props);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const LocalDateCell = (props) => {
    const date = props.dataItem[props.field];
    const formattedDate = date ? formatServiceDate(date) : "";
    return <td title={formattedDate}>{formattedDate}</td>;
  };

  const NameCell = (props) => {
    const { dataItem, field } = props;
    return (
      <td className="k-table-td" title={dataItem[field]}>
        <span>{dataItem[field]}</span>
      </td>
    );
  };

  const capitalizeString = (props) => {
    const str = props.dataItem.period_type;
    return (
      <td className="k-table-td" title={str}>
        <span>{str ? str.charAt(0).toUpperCase() + str.slice(1) : ""}</span>
      </td>
    );
  };

  const colRenders = (columnList) => {
    return columnList.map((col, idx) => {
      if (col.field === "is_selected") {
        col["aditionalParam"] = {
          assignCheckboxProps: {
            checked: isHeaderChecked,
            onChange: headerCheckboxOnChange,
            disabled: data.length === 0 || (filterData.isFilter && data.length === 0),
          },
          dataTableProps: {
            id: "is_selected",
          },
        };
      }

      return col.show && col.title !== "" ? (
        <Column
          {...columnMenuProps(col)}
          key={idx}
          sortable={col.field === "is_selected" || col.field === "total_quantity" || col.field === "budget" ? false : true}
          width={col.width}
          cell={
            col.field === "is_selected"
              ? CheckboxCell
              : col.field === "status"
                ? StatusCell
                : col.field === "budget"
                  ? AmountCell
                  : col.field === "total_quantity"
                    ? QuantityCell
                    : col.field === "ts_date_local" || col.field === "post_date_local"
                      ? LocalDateCell
                      : col.field === "period_type"
                        ? capitalizeString
                        : NameCell
          }
          resizable={col.field === "is_selected" ? false : true}
          editable={false}
          format={col.format}
        />
      ) : (
        false
      );
    });
  };

  const exitEdit = () => {
    let newData = data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    setData(newData);
  };

  const customRowRender = (tr, props) => (
    <RowRender
      originalProps={props}
      tr={tr}
      onRowDoubleClick={handleDoubleClick}
      // editField={editField} exitEdit={exitEdit}
    />
  );
  const customCellRender = (td, props) => {
    return (
      <CellRender
        navigatable={true}
        originalProps={props}
        td={td}
        // enterEdit={enterEdit}
        // editField={editField}
        //onRowClick={onRowClick}
        updateActBtn="grid-incell-update"
        cancelActBtn="grid-incell-cancel"
      />
    );
  };
  const onRowClick = () => {};

  const enterEdit = (dataItem, field) => {
    let newData = data.map((item) => ({
      ...item,
      inEdit: item.timesheet_mstr_key === dataItem.timesheet_mstr_key ? field : undefined,
    }));

    setData(newData);
  };

  useEffect(() => {
    if (isCheckColumn && columnData.length > 0) {
      setGridColumns(columnData);
      setCheckColumn(false);
    }
  }, [isCheckColumn]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  let GroupColumn = React.useMemo(() => colRenders(gridColumns), [gridColumns, isHeaderChecked, filterField, data]);

  const getExportData = async (payload) => {
    setExportData([]);
    if (!payload.in_tenant_id) return;
    const { in_page_row_offset, in_page_rows, ...restPayload } = payload;

    const res = await Action.fetchTimesheetsDataAsync(restPayload);
    const result = res.map((element) => ({
      ...element,
      ts_date_local: element?.ts_date_local ? formatServiceDate(element.ts_date_local) : "",
      post_date_local: element?.post_date_local ? formatServiceDate(element.post_date_local) : "",
      total_quantity: formatTimesheetQuantity(element),
      budget: `$ ${element.budget.toFixed(2)}`,
      status: element?.status?.display_name,
    }));
    setExportData(result);
  };

  const handleApproveAction = () => {
    handleCancelAction();
    if (data.filter((it) => it.is_selected === 1).length > 0) {
      Action.onSubmitClick("4").then((heldKeys) => {
        if (Array.isArray(heldKeys) && heldKeys.length > 0) {
          setHoldPopup({ isVisible: true });
        }
        onRefreshClick();
      });
    }
  };
  const handleRejectAction = () => {
    handleCancelAction();
    if (data.filter((it) => it.is_selected === 1).length !== 0) {
      Action.onSubmitClick("3").then((res) => {
        onRefreshClick();
      });
    }
  };
  const handleCancelAction = () => {
    // setApproveDialogVisible(false)
    // setRejectDialogVisible(false)

    setConfirmationPopup({
      ...confirmationPopup,
      isVisible: false,
      type: "",
      actionBtn: [],
      data: {},
      action: "",
    });
  };

  return (
    <div className="Main providerPayRequestOverview">
      <div className="content">
        <div className="content-head">
          <HeaderPage pageProps={pageProps} headerConfig={headerConfig} />
        </div>
        <div className="content-body">
          <div className="pay-request-overview-content">
            <div className="pay-request-overview-tabs">
              <div className="custom-tabs-container">
                <div className="custom-tabs">
                  <div
                    className={`custom-tab ${selectedTab === "ALL" ? "active" : ""}`}
                    onClick={() => handleTabChange("ALL")}
                  >
                    All
                  </div>
                  <div
                    className={`custom-tab ${selectedTab === "PENDING" ? "active" : ""}`}
                    onClick={() => handleTabChange("PENDING")}
                  >
                    Pending
                  </div>
                  <div
                    className={`custom-tab ${selectedTab === "APPROVED" ? "active" : ""}`}
                    onClick={() => handleTabChange("APPROVED")}
                  >
                    Approved
                  </div>
                  {holdEnabled !== false && (
                    <div
                      className={`custom-tab ${selectedTab === "HOLD" ? "active" : ""}`}
                      onClick={() => handleTabChange("HOLD")}
                    >
                      Hold
                    </div>
                  )}
                  <div
                    className={`custom-tab ${selectedTab === "REJECTED" ? "active" : ""}`}
                    onClick={() => handleTabChange("REJECTED")}
                  >
                    Rejected
                  </div>
                </div>
              </div>
            </div>

            <div className="pay-request-overview-controls">
              <div className="filter-row">
                <div className="filter-item">
                  <label className="filter-label">Start Date</label>
                  <DatePicker
                    value={startDate}
                    onChange={handleStartDateChange}
                    placeholder="Start Date"
                    className="filter-datepicker"
                  />
                  {dateErrors.startDate && <div className="date-validation-error">{dateErrors.startDate}</div>}
                </div>
                <div className="filter-item">
                  <label className="filter-label">End Date</label>
                  <DatePicker
                    value={endDate}
                    onChange={handleEndDateChange}
                    placeholder="End Date"
                    className="filter-datepicker"
                  />
                  {dateErrors.endDate && <div className="date-validation-error">{dateErrors.endDate}</div>}
                </div>

                <div className="filter-item">
                  <label className="filter-label">Pay Request Type</label>
                  <MultiSelect
                    name="payRequestTypeDataValue"
                    dataItemKey="id"
                    textField="text"
                    data={payRequestTypeFields.payRequestTypeData}
                    valueData={payRequestTypeFields.payRequestTypeDataValue}
                    autoClose={false}
                    loading={payRequestTypeFields.isPayRequestTypeDataLoading}
                    disabled={payRequestTypeFields.isPayRequestTypeDataLoading}
                    placeholder="Select Pay Request Types"
                    className="filter-multiselect k-multiselect-wrap"
                    isSelectALl={true}
                    dataList={transformPayRequestData}
                    onOpen={() =>
                      onOpenChange(
                        setPayRequestTypeFields,
                        transformPayRequestData,
                        "payRequestTypeData",
                        payRequestTypeFields,
                        payRequestTypeFields.payRequestTypeDataValue
                      )
                    }
                    onChange={(value) =>
                      setPayRequestTypeFields({
                        ...payRequestTypeFields,
                        payRequestTypeDataValue: value,
                      })
                    }
                    onFilterChange={(e) => filterChange(e, setPayRequestTypeFields, transformPayRequestData, "payRequestTypeData")}
                    onBlur={() => handleBlurDropdown(setPayRequestTypeFields)}
                  />
                </div>
                <div className="filter-item">
                  <label className="filter-label">Provider</label>
                  <MultiSelect
                    name="providerDataValue"
                    dataItemKey="id"
                    textField="text"
                    data={providerFields.providerData}
                    valueData={providerFields.providerDataValue}
                    autoClose={false}
                    loading={providerFields.isProviderDataLoading}
                    disabled={providerFields.isProviderDataLoading}
                    placeholder="Select Providers"
                    className="filter-multiselect k-multiselect-wrap"
                    isSelectALl={true}
                    dataList={transformProviderData}
                    onOpen={() =>
                      onOpenChange(setProviderFields, transformProviderData, "providerData", providerFields, providerFields.providerDataValue)
                    }
                    onChange={(value) =>
                      setProviderFields({
                        ...providerFields,
                        providerDataValue: value,
                      })
                    }
                    onFilterChange={(e) => filterChange(e, setProviderFields, transformProviderData, "providerData")}
                    onBlur={() => handleBlurDropdown(setProviderFields)}
                  />
                </div>

                <div className="filter-item search-button-container">
                  <label className="filter-label">&nbsp;</label>
                  <Tooltip anchorElement="target" position="top" openDelay={100}>
                    <button
                      className="search-button"
                      onClick={() => {
                        onClearFilter();
                        setSearchFilter((pre) => !pre);
                      }}
                      disabled={dateErrors.startDate || dateErrors.endDate}
                      title="Filter Data"
                    >
                      <span className="k-icon k-font-icon k-i-search" />
                    </button>
                  </Tooltip>
                </div>

                <div className="filter-item action-buttons-container">
                  <label className="filter-label">&nbsp;</label>

                  <div className="action-buttons">
                    <Button
                      className="approve-action-button"
                      disabled={data.filter((it) => it.is_selected === 1).length === 0}
                      onClick={() => {
                        // setApproveDialogVisible(true)
                        setConfirmationPopup({
                          ...confirmationPopup,
                          title: "Confirm Approval",
                          desc: "",
                          isVisible: true,
                          type: "APPROVE_CONFIRM",
                          actionBtn: APPROVE_BTN_ACTIONS(handleCancelAction, handleApproveAction),
                          action: "",
                          isCustomDesc: true,
                          customComponent: (
                            <div className="confirmation-content">
                              <p>Are you sure you want to approve the following pay request(s)?</p>
                              <SelectedPayRequestsList selectedItems={selectedTimesheetKeys} />
                            </div>
                          ),
                        });
                      }}
                    >
                      Approve
                    </Button>
                    <Button
                      className="reject-action-button"
                      disabled={data.filter((it) => it.is_selected === 1).length === 0}
                      onClick={() => {
                        // setRejectDialogVisible(true)
                        setConfirmationPopup({
                          ...confirmationPopup,
                          title: "Confirm Approval",
                          desc: "",
                          isVisible: true,
                          type: "REJECT_CONFIRM",
                          actionBtn: REJECT_BTN_ACTIONS(handleCancelAction, handleRejectAction),
                          action: "",
                          isCustomDesc: true,
                          customComponent: (
                            <div className="confirmation-content">
                              <p>Are you sure you want to reject the following pay request(s)?</p>
                              <SelectedPayRequestsList selectedItems={selectedTimesheetKeys} maxVisible={10} />
                            </div>
                          ),
                        });
                      }}
                    >
                      Reject
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {isAPICalling && <LoadingPanel gridId="pay-request-overview-grid" />}
              {gridColumns.length > 0 ? (
                <DataTable
                  isAPICalling={isAPICalling}
                  initialLoading={true}
                  data={data}
                  id="pay-request-overview-grid"
                  customColumn={GroupColumn}
                  columns={gridColumns}
                  isPagination={true}
                  gridHeight={dateErrors.startDate || dateErrors.endDate ? "52vh" : "58vh"}
                  isSortable={true}
                  scrollable="scrollable"
                  pageData={pageData}
                  rowRender={customRowRender}
                  cellRender={customCellRender}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  defaultPageSize={defaultPageSize}
                  handlePageChange={handlePageChange}
                  editField={editField}
                  dataCount={dataCount}
                  dataItemKey="timesheet_mstr_key"
                  handleColumnMenu={handleColumnMenu}
                  refreshClick={onRefreshClick}
                  onRowDoubleClick={handleDoubleClick}
                  initialFilter={filterField}
                  initialSort={sortField}
                  reorderable={true}
                  itemChange={handleItemChange}
                  onClearFilter={onClearFilter}
                  isExportDataClick={exportDataClick}
                  setExportData={setExportDataClick}
                  exportData={exportData}
                  getExportData={getExportData}
                  fileName={"Pay_Request_Overview.xlsx"}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {viewDialogData.isVisible && (
        <PendingApprovalDialog
          visible={viewDialogData.isVisible}
          onClose={() => setViewDialogData({ isVisible: false, data: null })}
          rowData={viewDialogData.data}
          onRefresh={onRefreshClick}
          onHold={() => setHoldPopup({ isVisible: true })}
        />
      )}

      {holdPopup.isVisible && (
        <DialogComponent
          title="Pay Request Status"
          visible={holdPopup.isVisible}
          onCancelConfirm={() => setHoldPopup({ isVisible: false })}
          width={520}
          height={260}
          isShowOneButton={true}
          primBtnText="Ok"
          onPrimButton={() => setHoldPopup({ isVisible: false })}
          isCustomDesc={true}
          customComponent={
            <p>
              Pay Request(s) have been approved and are currently{" "}
              <strong style={{ color: "#00A1E4" }}>on hold</strong> for payroll processing. Once payroll processing
              is complete, the approved Pay Request(s) will automatically move to the{" "}
              <strong style={{ color: "#00A1E4" }}>Comp Admin Review</strong> queue.
            </p>
          }
        />
      )}
      {/* {rejectDialogVisible && (
                <ConfirmDialog
                    visible={rejectDialogVisible}
                    description="Are you sure you want to reject the selected pay request?"
                    btnCancel={'Cancel'}
                    btnSubmit={'Reject'}
                    onCancelClick={handleCancelAction}
                    onSubmitClick={() => handleRejectAction()}
                    className="reject"
                    title="Confirm Rejection"
                />
            )}

            {approveDialogVisible && (
                <ConfirmDialog
                    visible={approveDialogVisible}
                    description="Are you sure you want to approve the selected pay request?"
                    btnCancel={'Cancel'}
                    btnSubmit={'Approve'}
                    onCancelClick={handleCancelAction}
                    onSubmitClick={() => handleApproveAction()}
                    className="approve"
                    title="Confirm Approval"
                />
            )} */}

      {confirmationPopup.isVisible ? (
        <DialogComponent
          title={confirmationPopup.title}
          onCancelConfirm={handleCancelAction}
          width={"800"}
          height={"auto"}
          className={"Dialog-Approve-Reject"}
          desc={confirmationPopup.desc}
          visible={confirmationPopup.isVisible}
          actionBtn={confirmationPopup.actionBtn}
          titleClassName={confirmationPopup.type === "APPROVE_CONFIRM" ? "approve-confirm" : "reject-confirm"}
          closeIcon={false}
          isCustomDesc={confirmationPopup.isCustomDesc}
          customComponent={confirmationPopup.customComponent}
        />
      ) : null}
    </div>
  );
};

export default ProviderRequest;